const FormCCPA = () => {
	return (
		<div className='container pb-20'>
			<iframe
				src='https://submit-irm.trustarc.com/services/validation/20f0b8a7-e0e5-40d3-ae8c-8002b2cd3c42'
				style={{ border: 'none', height: 1400, width: '100%' }}
			></iframe>
		</div>
	);
};

export default FormCCPA;
